import { useEffect, useState } from 'react';
import jwt_decode from 'jwt-decode';

import StorageService from 'api-services/storage-service';
import { message } from 'antd';
import { SUBSCRIPTION_STATUS } from 'utilities/constants';
import eventEmitter from 'utilities/event-emitter';

export default function useDecodeToken() {
  const [tokenData, setTokenData] = useState({
    userId: null,
    subscriptionId: null,
    planId: null,
    subscriptionStatus: null,
    botsAllowed: 0,
    conversationCountAllowed: 0,
    dataSizeAllowed: 0,
  });

  const updateTokenData = (token) => {
    if (token) {
      try {
        // Decode the token
        const decoded = jwt_decode(token);

        if (decoded.subscriptionStatus === SUBSCRIPTION_STATUS.CONSUMED) {
          message.destroy();
          message.info('You have consumed your subscription. Kindly renew to keep using our services, Thanks.', 0); // Pass 0 as the second parameter to make the message sticky
        }

        // Extract userId and subscriptionId from the decoded token
        const tData = {
          userId: decoded.id,
          subscriptionId: decoded.subscriptionId,
          planId: decoded.planId,
          subscriptionStatus: decoded.subscriptionStatus,
          role: decoded.role.id,
          botsAllowed: decoded.botsAllowed,
          conversationCountAllowed: decoded.conversationCountAllowed,
          dataSizeAllowed: decoded.dataSizeAllowed,
        };
        // Update the state with the decoded data
        setTokenData(tData);
      } catch (error) {
        console.error('Error decoding token:', error);
      }
    }
  };

  useEffect(() => {
    // Retrieve the token from local storage
    const token = StorageService.getItem('authToken'); // Change 'authToken' to your token key
    updateTokenData(token);

    // to notify changes in user information anywhere in the app.
    eventEmitter.on('userInfoUpdated', updateTokenData);

    // Clean up the listener when the component unmounts.
    return () => {
      eventEmitter.off('userInfoUpdated', updateTokenData);
    };
  }, []);

  return tokenData;
}
